"use client";

import { prayerSchema } from "../../../lib/types/schema/prayer/prayerSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyPrayer } from "./keyPrayer";

export type UseRequestPrayerProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestPrayer = ({ id, ...props }: UseRequestPrayerProps) => ({
  query: useRequestQuery({
    enabled: typeof id === "number",
    ...props,
    queryFnRequestProps: {
      schema: prayerSchema,
      urlBackendPath: `/prayers/${id}`,
    },
    queryKey: keyPrayer({ id }),
  }),
});
